export default {
  SEARCH_CATALOG_ALLIANZ_RELATIONSHIP_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_RELATIONSHIP_QUERY'),
  CATALOG_ALLIANZ_RELATIONSHIP_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_RELATIONSHIP_REPOSITORY'),
  CATALOG_ALLIANZ_RELATIONSHIP_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_RELATIONSHIP_STATE_MANAGER'),
};
